import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,

} from "@mui/material";
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePaymentPdf } from "../../Accounts/PaymentVoucherPrint";
import { Chip } from "@mui/material";
const PaymentVouchers = ({data}) => {
 

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };


    const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
    

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "48vh",
            overflow: "auto"
          }}
        >
          <Table
            stickyHeader
            size="small"
            sx={{
              minWidth: 1600,
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                backgroundColor: "#f5f5f5",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f5f5f5",
                  "& th": {
                    fontWeight: "bold",
                    color: "#333",
                    borderBottom: "1px solid #999",
                    whiteSpace: "nowrap",
                  },
                }}
              >
              
                <TableCell
                  sx={{
                    position: "sticky",
      
                    backgroundColor: "#f5f5f5",
                    zIndex: 3,
                  }}
                >
                  S.No.
                </TableCell>

                <TableCell> Voucher No</TableCell>
          
                <TableCell>Paid Amt</TableCell>
                {/* <TableCell>Rec Amt</TableCell>
                <TableCell>Bal Amt</TableCell> */}
                <TableCell>Project</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>Ladger Name</TableCell>
                {/* <TableCell>Journal Voucher</TableCell>
                <TableCell>Purchase voucher</TableCell> */}

                <TableCell>Payment Mode</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Approved By</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#f5f5f5",
                    zIndex: 3,
                    // minWidth: 180, // Increase width so all icons fit
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((voucher, index) => (
                <TableRow
                  hover
                  key={index}
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,

                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                      "& td": {
                        backgroundColor: "#e3f2fd !important",
                      },
                    },
                    "& td": {
                      paddingTop: "2px !important",
                      paddingBottom: "2px !important",
                      fontSize: { xs: "0.75rem", sm: "0.8125rem" }, // responsive font
                      whiteSpace: "nowrap",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "white" : "inherit",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "inherit",
                    },
                  }}
                >
                 
                  <TableCell
                    sx={{
                      position: "sticky",
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                    }}
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell>{voucher.payment_number}</TableCell>

                
                  <TableCell>
                    {voucher.total_amount?.toLocaleString("en-IN")}
                  </TableCell>
                  {/* <TableCell>
                    {voucher.receipt_amount?.toLocaleString("en-IN")}
                  </TableCell>
                  <TableCell>
                    {voucher.balance_amount?.toLocaleString("en-IN")}
                  </TableCell> */}
                  <TableCell>{voucher.project_name}</TableCell>
                  <TableCell>{voucher.division_name}</TableCell>
                  <TableCell>{voucher.supplier_name || voucher.expense_name || voucher.supplier_name || voucher.advanceworker_name || voucher.imprest_name || voucher.party_name}</TableCell>
                  {/* <TableCell>{voucher.gen_number}</TableCell>
                  <TableCell>{voucher.purchase_number}</TableCell> */}

                  <TableCell>{voucher.payment_mode}</TableCell>
                  <TableCell>{formatDate(voucher.created_at)}</TableCell>
                  <TableCell>{voucher.created_by_name}</TableCell>
                  <TableCell>{voucher.approved_name}</TableCell>
                  {/* <TableCell>{voucher.remarks || ""}</TableCell> */}
                  <TableCell>
                    <Tooltip title={voucher.remarks || ""} arrow>
                      <span>{truncateText(voucher.remarks || "", 20)}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 180, // Consistent width
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                   
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        color="warning"
                        size="small"
                        onClick={() => generatePaymentPdf(voucher)}
                      >
                        <Print fontSize="small" />
                      </IconButton>
                      {typeof voucher.attachment === "string" ? (
                        <a
                          href={`${voucher.attachment}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            color="info"
                            size="small"
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        </a>
                      ) : voucher.attachment instanceof File ? (
                        // voucher.attachment.name
                        <a
                          href={URL.createObjectURL(voucher.attachment)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            color="info"
                            size="small"
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        </a>
                      ) : (
                        <span style={{ display: "inline-block", width: 30 }} />
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          
            </TableBody>
          </Table>
        </TableContainer>
   


    </>
  );
};

export default PaymentVouchers;
